"use strict";

exports.__esModule = true;
exports.default = FooterActions;
var _preact = require("preact");
function FooterActions(_ref) {
  var cancel = _ref.cancel,
    done = _ref.done,
    i18n = _ref.i18n,
    selected = _ref.selected;
  return (0, _preact.h)("div", {
    className: "uppy-ProviderBrowser-footer"
  }, (0, _preact.h)("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary",
    onClick: done,
    type: "button"
  }, i18n('selectX', {
    smart_count: selected
  })), (0, _preact.h)("button", {
    className: "uppy-u-reset uppy-c-btn uppy-c-btn-link",
    onClick: cancel,
    type: "button"
  }, i18n('cancel')));
}